import i18n from 'src/i18n';
import Formatter from 'src/class/Formatter';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'daily_hours',
            label: i18n.t('labor.daily_hours_per_worker'),
            align: 'center',
            minWidth: 200,
            sortable: true,
        },
        {
            prop: 'weekly_overtime_hours',
            label: i18n.t('labor.weekly_overtime_hours_per_worker'),
            align: 'center',
            minWidth: 200,
            sortable: true,
        },
        {
            prop: 'daily_minimum_wage',
            label: i18n.t('labor.daily_minimum_wage'),
            align: 'center',
            minWidth: 180,
            sortable: true,
            formatter: (row, column) => {
                return Formatter.formatNumber(Number(row[column.property]));
            },
        }
    ];
    return { tableColumns };
};

export default configTable;